export default "__VITE_PUBLIC_ASSET__f3f3ab23__"